import { createClient } from '@supabase/supabase-js'
import { viewAsFetch } from './viewAsState'

const url = import.meta.env.VITE_SUPABASE_URL
const key = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY

if (!url || !key) {
  // Fail loudly at load rather than producing a client that 401s on every call.
  // A missing Netlify environment variable is the most likely cause and is
  // otherwise indistinguishable from a broken RLS policy.
  throw new Error(
    'VITE_SUPABASE_URL and VITE_SUPABASE_PUBLISHABLE_KEY must be set. ' +
      'Locally: copy .env.example to .env.local. ' +
      'On Netlify: Site configuration → Environment variables.',
  )
}

export const supabase = createClient(url, key, {
  // 176. View as: adds `x-view-as` to /rest/v1 calls while this tab is
  // viewing as somebody, and nothing otherwise. See lib/viewAsState.ts.
  global: { fetch: viewAsFetch((input, init) => fetch(input, init)) },
  auth: {
    // MUST stay true, and this was got wrong once — worth the paragraph.
    //
    // The reasoning for false was "we type codes, so there is no callback to
    // parse". That is wrong about what a magic link does. Clicking one hits
    // Supabase's /verify endpoint, which creates a real session server-side
    // and then redirects here with the tokens in the URL fragment. With
    // detection off the client silently discards them, so the person is
    // authenticated in the database and staring at the sign-in form. It looks
    // exactly like the email failed. It cost a live debugging session.
    //
    // True means any link that does get clicked completes. The typed-code
    // path does not depend on this either way.
    detectSessionInUrl: true,
    persistSession: true,
    autoRefreshToken: true,
  },
})
